import React from 'react'
import { withRouter } from 'react-router-dom'
import ReactQuill from 'react-quill'
import BaseBar from './BaseBar'
import Tags from './Tags'
import Tag from './Tag'
import * as firebase from 'firebase'
import 'react-quill/dist/quill.snow.css'
/* REDUX */
import { connect } from 'react-redux'
import { createReport, updateReport } from '../../actions/create'
import { loadDelta } from '../../actions/delta'
import { loadReport } from '../../actions/report'

var config = {
	apiKey: "AIzaSyBzTbmzfffuSZQDyC0W-PV_WStAMEJbV5k",
	authDomain: "theflightpost.firebaseapp.com",
	databaseURL: "https://theflightpost.firebaseio.com",
	storageBucket: "gs://theflightpost.appspot.com"
}

firebase.initializeApp(config)

let EMPTY_DELTA = { ops: [] }
let globalObject
let uploadTask

class Delta extends React.Component {
	render() {
		
		const { value, onChange, onChangeSelection, onFocus, onBlur, modules } = this.props
		
		return (
			<ReactQuill value={value} onChange={onChange} onChangeSelection={onChangeSelection} onFocus={onFocus} onBlur={onBlur} modules={modules} />
		)
	}
}

function dataURLToBlob(dataURL) {
    var BASE64_MARKER = ';base64,';
    if (dataURL.indexOf(BASE64_MARKER) == -1) {
        var parts = dataURL.split(',');
        var contentType = parts[0].split(':')[1];
        var raw = parts[1];

        return new Blob([raw], {type: contentType});
    }

    var parts = dataURL.split(BASE64_MARKER);
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;

    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], {type: contentType});
}

class Editor extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			title: '',
			blurb: '',
			value: EMPTY_DELTA,
			events: [],
			tags: []
		}
		
		this.onEditorChange = this.onEditorChange.bind(this)
		this.onEditorChangeSelection = this.onEditorChangeSelection.bind(this)
		this.onEditorFocus = this.onEditorFocus.bind(this)
		this.onEditorBlur = this.onEditorBlur.bind(this)
		
		this.handleInputChange = this.handleInputChange.bind(this)
		this.handlePublish = this.handlePublish.bind(this)
		this.handleUnpublish = this.handleUnpublish.bind(this)
		this.handleUpdate = this.handleUpdate.bind(this)
		this.handleSave = this.handleSave.bind(this)
		
		this.addTag = this.addTag.bind(this)
		this.removeTag = this.removeTag.bind(this)
		
		this.imageHandler = this.imageHandler.bind(this)
		this.firebaseHandler = this.firebaseHandler.bind(this)
		this.abortUpload = this.abortUpload.bind(this)
		
		this.verifyInputs = this.verifyInputs.bind(this)
	}
	
	componentWillMount() {
		const { type } = this.props
		const { path, report_id } = type
		if (path === 'edit') {
			this.props.loadReport(report_id)
			this.props.loadDelta(report_id)
		} else {
			// NEW DOCUMENT INIT
			this.setState({
				title: "Untitled",
				blurb: "Replace blurb here"
			})
		}
	}
	
	componentDidMount() {
		if (this.props.type.path === 'new') {
			this.props.createReport(this.state, false, null, (report_id) => this.props.history.push("/editor/edit/" + report_id))
		}
	}
	
	componentWillReceiveProps(nextProps) {
		const delta = nextProps.delta || this.state.value
		const report = nextProps.report || this.state.report
		const title = report.title || this.state.title
		const blurb = report.blurb || this.state.blurb
		const tags = report.tags || this.state.tags
		if (this.state.value.ops.length === 0) {
			this.setState({
				title: title,
				blurb: blurb,
				tags: tags,
				value: delta
			})
		}
	}
	
	/** QUILL HANDLER **/
	formatRange(range) {
		return range
			? [range.index, range.index + range.length].join(',')
			: 'none'
	}
	
	onEditorChange(value, delta, source, editor) {
		this.setState({
			value: editor.getContents(),
			events: [
				'text-change('+this.state.value+' -> '+value+')'
			].concat(this.state.events)
		});
	}
	
	onEditorChangeSelection(range, source) {
		this.setState({
			selection: range,
			events: [
				'selection-change('+
					this.formatRange(this.state.selection)
				+' -> '+
					this.formatRange(range)
				+')'
			].concat(this.state.events)
		});
	}
	
	onEditorFocus(range, source) {
		this.setState({
			events: [
				'focus('+this.formatRange(range)+')'
			].concat(this.state.events)
		});
	}
	
	onEditorBlur(previousRange, source) {
		this.setState({
			events: [
				'blur('+this.formatRange(previousRange)+')'
			].concat(this.state.events)
		});
	}
	
	onToggle() {
		this.setState({ enabled: !this.state.enabled });
	}
	
	onToggleReadOnly() {
		this.setState({ readOnly: !this.state.readOnly });
	}
	
	modules = {
		toolbar: {
			container: [['bold', 'italic'], [{ 'header': 2 }], [{ 'list': 'bullet' }], ['link', 'image'], ['clean']],
			handlers: {
				image: this.imageHandler
			}
		}
	}
	
	/** TAG HANDLERS **/
	addTag(tag) {
		this.setState({
			tags: this.state.tags.concat(tag)
		})
	}
	
	removeTag(index) {
		var newTags = this.state.tags.slice()
	    newTags.splice(index, 1)
	    this.setState({
		    tags: newTags
		});
	}
	
	/** INPUT HANDLER **/
	handleInputChange(e) {
		const target = e.target
	    const value = target.value
		const name = target.name
		
	    this.setState({
			[name]: value
	    });
	}
	
	/** FORM SUBMIT HANDLER **/
	
	verifyInputs() {
		const { title, blurb } = this.state
		if (!title || !blurb) {
			alert("Please complete all fields")
			return
		}
	}
	
	handlePublish() {
		this.verifyInputs()
		if (this.props.type.path === 'new') {
			this.props.createReport(this.state, true, () => this.props.history.push("/manage"))
		} else {
			this.props.updateReport(this.props.report_id, this.state, true, () => this.props.history.push("/manage"))
		}
	}
	
	handleUnpublish() {
		this.props.updateReport(this.props.report_id, this.state, false, () => this.props.history.push("/manage"))
	}
	
	handleUpdate(cb) {
		this.props.updateReport(this.props.report_id, this.state, this.props.published, cb)
	}
	
	handleSave(cb) {
		this.verifyInputs()
		this.props.updateReport(this.props.report_id, this.state, false, cb)
	}
	
	/** IMAGE HANDLER HANDLER **/
	imageHandler() {
		globalObject = this.quill
		let fileModule = document.getElementById('fileModule')
		fileModule.click()
	}
	
	firebaseHandler() {
		this.props.onModal(this.abortUpload);
		let fileModule = document.getElementById('fileModule')
		var file = fileModule.files[0];
		
		const { report_id } = this.props

	    if(file.type.match(/image.*/)) {
	        var reader = new FileReader();
	        reader.onload = function (readerEvent) {
	            var image = new Image();
	            image.onload = function (imageEvent) {
	
	                // Resize the image
	                var canvas = document.createElement('canvas'),
	                    max_size = 2000,
	                    width = image.width,
	                    height = image.height;
	                if (width > height) {
	                    if (width > max_size) {
	                        height *= max_size / width;
	                        width = max_size;
	                    }
	                } else {
	                    if (height > max_size) {
	                        width *= max_size / height;
	                        height = max_size;
	                    }
	                }
	                canvas.width = width;
	                canvas.height = height;
	                canvas.getContext('2d').drawImage(image, 0, 0, width, height);
	                var dataUrl = canvas.toDataURL('image/jpeg');
	                var resizedImage = dataURLToBlob(dataUrl);
	                
	                var storageRef = firebase.storage().ref();
	                if (report_id) {
		                uploadTask = storageRef.child('assets/reports/' + report_id + '/' + Date.now() + '.jpg').put(resizedImage);
	                } else {
		                uploadTask = storageRef.child('assets/temp/' + Date.now() + '.jpg').put(resizedImage);
	                }
				    uploadTask.on('state_changed', function(snapshot){
						var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
						this.props.onUpdate(Math.round(Number(progress)));
					}.bind(this), function(error) {
						console.log(error);
					}.bind(this), function() {
						var downloadURL = uploadTask.snapshot.downloadURL;
						console.log(downloadURL)
						var range = globalObject.getSelection(window.focus=true);
						globalObject.insertEmbed(range.index, 'image', downloadURL);
						fileModule.value = '';
						this.props.onClose();
					}.bind(this));
	            }.bind(this)
	            image.src = readerEvent.target.result;
	        }.bind(this)
	        reader.readAsDataURL(file);
	    }
	}
	
	abortUpload() {
		uploadTask.cancel();
	}
	
	render() {
		
		const { title, blurb, tags } = this.state
		const { published } = this.props
		
		const renderTags = tags.map((tag, key) => {
			return (
				<Tag key={ key } index={ key } tag={ tag } removeTag={ this.removeTag } />
			)
		})
		
		return (
			<form>
				<div className="editor shared">
					<h4 className="title">My Details</h4>
					<div className="block">
						<div className="row d-flex align-items-center">
							<div className="col-3 col-sm-2 col-lg-1">
								<div className="left">
									<span>Title</span>
								</div>
							</div>
							<div className="col-9 col-sm-10 col-lg-11">
								<div className="right">
									<input type="text" name="title" value={ title } onChange={ this.handleInputChange } maxLength="77" />
								</div>
							</div>
						</div>
					</div>
					<div className="block">
						<div className="row d-flex align-items-center">
							<div className="col-3 col-sm-2 col-lg-1">
								<div className="left">
									<span>Blurb</span>
								</div>
							</div>
							<div className="col-9 col-sm-10 col-lg-11">
								<div className="right">
									<input type="text" name="blurb" value={ blurb } onChange={ this.handleInputChange } maxLength="154" />
								</div>
							</div>
						</div>
					</div>
					<div className="block">
						<div className="row d-flex align-items-top">
							<div className="col-3 col-sm-2 col-lg-1">
								<div className="left">
									<span>Story</span>
								</div>
							</div>
							<div className="col-9 col-sm-10 col-lg-11">
								<div className="right">
									<div id="editor">
										<Delta value={this.state.value} onChange={this.onEditorChange} onChangeSelection={this.onEditorChangeSelection} onFocus={this.onEditorFocus} onBlur={this.onEditorBlur} modules={this.modules} />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="block">
						<div className="row d-flex align-items-center">
							<div className="col-3 col-sm-2 col-lg-1">
								<div className="left">
									<span>Tags</span>
								</div>
							</div>
							<div className="col-9 col-sm-10 col-lg-11">
								<div className="right">
									<div className="tags">
										<div>
											{ renderTags }
										</div>
										<Tags addTag={ this.addTag } tags={ this.state.tags } />
										<p id="error-msg" className="error-msg"></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<BaseBar handlePublish={ this.handlePublish } handleUnpublish={ this.handleUnpublish } handleUpdate={ this.handleUpdate } handleSave={ this.handleSave } published={ published } />
				<input type="file" id="fileModule" style={{position:'absolute',top:'-100px'}} onChange={ this.firebaseHandler } hidden/>
			</form>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.type.report_id
	const { deltaById, reportById } = state
	const delta = deltaById[report_id] || {}
	const story = delta.delta || {}
	const reportObj = reportById[report_id] || {}
	const report = reportObj.report || {}
	const published = report.published || false
	return {
		report_id,
		report,
		published,
		delta: story.story
	}
}

export default withRouter(connect(mapStateToProps, { createReport, updateReport, loadDelta, loadReport })(Editor))


// WEBPACK FOOTER //
// ./src/components/Editor/Editor.js